import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Dropzone from 'react-dropzone'

import SizesMap, { defaultSize, sizes } from './Input.file.sizes'
import { colors } from '../../../constants'

const Wrapper = styled.div`
    background: ${colors.greylightest};
    ${({ borderColor }) => (borderColor ? `border: 3px dashed ${borderColor};` : `border: 3px dashed ${colors.greylight};`)}
    border-radius: 3px;
    color: ${colors.grey};
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 5px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 10px;
    text-transform: initial;

    &:active,
    &:focus,
    &:hover {
        border: 3px dashed ${colors.greyDark};
    }

    ${({ error }) =>
        error &&
        `
    border: 1px solid ${colors.red};
  `}

    ${({ size }) => {
        switch (size) {
            case SizesMap.sm:
                return 'width: 100%;'
            case SizesMap.md:
                return 'width: 100%;'
            case SizesMap.lg:
                return 'width: 100%;'
            default:
                return ''
        }
    }}
    ${({style})=>style}
`

const InputText = React.forwardRef((props, ref) => {
    const {
        accept,
        borderColor,
        children,
        error,
        id,
        multiple,
        name,
        onChange,
        size,
        style,
        value,
        ...rest
    } = props

    return (
        <Dropzone
            accept={accept}
            ref={ref}
            onDrop={(acceptedFiles) =>
                onChange({
                    target: { name, files: acceptedFiles },
                })
            }
            multiple={multiple}
        >
            {({ getRootProps, getInputProps }) => (
                <section>
                    <Wrapper
                        style={style}
                        error={error}
                        borderColor={borderColor}
                        size={size}
                        {...getRootProps()}
                        {...rest}
                    >
                        <input id={id} {...getInputProps()} />
                        {children}
                        {!children && (
                            <p>
                                <span style={{ textDecoration: 'underline' }}>Choose a file&nbsp;</span>
                                or drag it here...
                                <br />
                                {value.map(({ path }) => path).join(' ')}
                            </p>
                        )}
                    </Wrapper>
                </section>
            )}
        </Dropzone>
    )
})

InputText.propTypes = {
    accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    borderColor: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    children: PropTypes.node,
    error: PropTypes.bool,
    multiple: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    size: PropTypes.oneOf(sizes),
    style: PropTypes.object,
    value: PropTypes.arrayOf(PropTypes.instanceOf(File)),
}

InputText.defaultProps = {
    accept: '',
    error: false,
    multiple: false,
    name: '',
    onChange: () => null,
    size: defaultSize,
    value: [],
    borderColor: null,
}

export default InputText
